import { config } from '@/config/env'

export interface UserModule {
  id: string
  name: string
  description: string
  createdAt: string
  updatedAt: string
}

export interface UserModuleAssignment {
  moduleId: string
  isActive: boolean
  module: UserModule
}

class UserAssignmentsService {
  private baseUrl: string

  constructor() {
    this.baseUrl = config.apiBaseUrl
  }

  private getToken(): string | null {
    return localStorage.getItem('access_token')
  }

  async getUserModules(userId: string): Promise<UserModuleAssignment[]> {
    const token = this.getToken()
    const response = await fetch(`${this.baseUrl}/user-assignments/users/${userId}/modules`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error('Error al cargar módulos del usuario')
    }

    return response.json()
  }
}

export const userAssignmentsService = new UserAssignmentsService()
